module.exports = __webpack_public_path__ + "static/media/left kneecap cartoon.079a8217.png";